<div class="container-fluid" style="padding-top: 150px;">
    <div class="row">
        <div class="col-sm-6 bgx">
            <div class="container-fluid" style="margin-top:25px">
                <h1 class="text-white">Contact Us</h1>
                <p class="text-light">MM2100 FF No.2, Cibitung</p>
                <p class="text-light">Bekasi 17520</p>
                <p class="text-light">Indonesia</p>
                <br>
                <p class="text-light"><fa-icon [icon]="faMail"></fa-icon> customer.support@sukandaonelink.com</p>
                <p class="text-light"><i class="fa fa-whatsapp"></i> whatsapp 081285015025 (text only)</p>
                <p class="text-light"><fa-icon [icon]="faPhone"></fa-icon> 1500982</p>
                <p class="text-light"><fa-icon [icon]="faWeb"></fa-icon> sukandadjaya.com</p>
                <p class="text-light"><fa-icon [icon]="faClock"></fa-icon> Operational Hours : Mon-Fri 08.00-17.00 WIB</p>
                <p class="text-light" style="margin-left: 265px;">Sat 08.00-12.00 WIB</p>
                <p class="text-light" style="margin-left: 265px;">Exclude Public Holidays</p>
                <!-- <p class="text-light">Operational Hours :</p>
                <p class="text-light">Mon-Fri 8.00-17.00 WIB</p>
                <p class="text-light">Sat 08.00-12.00 WIB</p>
                <p class="text-light">(Exclude public holiday)</p> -->
                <a class="text-light" href="https://sukandaonline.typeform.com/to/fLCeKsPL">Feedback Form</a>
                <br>
                <br>
            </div>
        </div>
        
        <div class="col-sm-6 bgx bg-img">
            <div class="container-fluid">

                <form [formGroup]="complaintForm" (ngSubmit)="submitForm()" class="form-keluhan">
                    <h3>How can we help you?</h3>
                    <hr>
                    <div class="form-group">
                        <label for="pwd">Name</label>
                        <input type="text" placeholder="Name" class="form-control" id="name-text" name="name"
                            formControlName="name" required>
                    </div>
                    <div *ngIf="submitted && f.name.invalid" class="invalid">
                        <div *ngIf="f.name.errors.required">&#65121; Name can't be empty.</div>
                    </div>
                    <div class="form-group">
                        <label for="email">Email</label>
                        <input type="email" placeholder="Email@example.com" class="form-control" id="email" name="email"
                            formControlName="email" required>
                    </div>
                    <div *ngIf="submitted && f.email.invalid" class="invalid">
                        <div *ngIf="f.email.errors.required">&#65121; Email address can't be empty.</div>
                        <div *ngIf="f.email.errors.email">
                            &#65121; Please provide a valid email address.
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="phone">Phone</label>
                    </div>
                    <div>
                        <input type="text" class="form-control" id="phone" name="phone" formControlName="phone"
                            ng2TelInput [ng2TelInputOptions]="{initialCountry: 'id'}" required>
                    </div>
                    <div *ngIf="f.phone.touched && f.phone.invalid" class="invalid">
                        <div *ngIf="f.phone.errors.required">Phone number can't be empty</div>
                        <div *ngIf="f.phone.errors.pattern">Please provide a valid phone number.</div>
                        <div *ngIf="f.phone.errors?.minlength">
                            &#65121; Min 10 Character.
                        </div>
                        <div *ngIf="f.phone.errors?.maxlength">
                            &#65121; Max 15 Character.
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="phone">Category</label>
                    </div>
                    <div class="selectWrapper">
                        <select name="category" (change)="changeCat($event)" formControlName="category">
                            <option value="">Choose Category</option>
                            <option *ngFor="let cat of Category" [ngValue]="cat" (change)="changeCat($event)">{{cat}}
                            </option>
                          </select>
                    </div>
                    <div *ngIf="submitted && f.category.invalid" class="invalid">
                        <div *ngIf="f.category.errors.required && f.category.touched && f.category.invalid">
                            &#65121; Please select category
                         </div>
                    </div>
                    
                    

                    <div class="form-group">
                        <label for="pwd">Message</label>
                        <textarea #msg class="form-control height-fix" rows="5" id="comment" name="complaint"
                            formControlName="complaint"required></textarea>
                    </div>
                    <div *ngIf="submitted && f.complaint.invalid" class="invalid">
                        <div *ngIf="f.complaint.errors.required">&#65121; Please write your message</div>
                    </div>
                    <br>
                    <div *ngIf="buttonSubmit">
                        <button  type="submit" class="btn btn-primary" >Send</button>
                    </div>
                    <div *ngIf="buttonLoading">
                        <button  class="btn btn-primary" disabled>
                            <span class="spinner-border spinner-border-sm"></span>
                            Loading..
                          </button>
                    </div>
                    
                   
                </form>


            </div>

        </div>
    </div>
</div>